import { createAction, createAsyncAction } from 'typesafe-actions'
import { type OrganisationServerType } from '@/connect-types/organisations/organisations.type'
import { type AccessVenueType } from './access.types'
import { type RollerVenuesType } from '@/pages/[org_id]/marketplace/apps/roller/roller.types'
import {
  type LinkGeneratorRequestType,
  type LinkGeneratorType,
} from './organisations.types'

export const organisationPushNewCustomer = createAction(
  'ORGANISATION_PUSH_NEW_CUSTOMER',
  (resolve: any) => (customer: OrganisationServerType) => resolve({ customer })
)

export const getOrganisationLinks = createAsyncAction(
  'GET_STORE_KIT_LINKS_REQUEST',
  'GET_STORE_KIT_LINKS_REQUEST_SUCCESS',
  'GET_STORE_KIT_LINKS_REQUEST_FAILURE'
)<{ orgId: string }, LinkGeneratorType[], Error>()

export const createOrganisationLinks = createAsyncAction(
  'CREATE_STORE_KIT_LINKS_REQUEST',
  'CREATE_STORE_KIT_LINKS_REQUEST_SUCCESS',
  'CREATE_STORE_KIT_LINKS_REQUEST_FAILURE'
)<LinkGeneratorRequestType, LinkGeneratorType, Error>()

export const getAccessBookingsVenues = createAsyncAction(
  'GET_ACCESS_BOOKINGS_VENUES_REQUEST',
  'GET_ACCESS_BOOKINGS_VENUES_SUCCESS',
  'GET_ACCESS_BOOKINGS_VENUES_FAILURE'
)<{ orgId: string }, AccessVenueType[], Error>()

export const getRollerData = createAsyncAction(
  'GET_ROLLER_REQUEST',
  'GET_ROLLER_REQUEST_SUCCESS',
  'GET_ROLLER_REQUEST_FAILURE'
)<{ orgId: string }, Record<string, RollerVenuesType>, Error>()

export const postRollerData = createAsyncAction(
  'POST_ROLLER_REQUEST',
  'POST_ROLLER_REQUEST_SUCCESS',
  'POST_ROLLER_REQUEST_FAILURE'
)<
  {
    orgId: string
    venues: Record<
      string,
      Omit<RollerVenuesType, 'id' | 'webhook' | 'webhookId'>
    >
  },
  Record<string, RollerVenuesType>,
  Error
>()

export const deleteRollerData = createAsyncAction(
  'DELETE_ROLLER_REQUEST',
  'DELETE_ROLLER_REQUEST_SUCCESS',
  'DELETE_ROLLER_REQUEST_FAILURE'
)<{ orgId: string; serial: string }, { serial: string }, Error>()
